import { BrowserCacheLocation, type Configuration, LogLevel, PublicClientApplication } from '@azure/msal-browser';

import { env } from './env';

const msalConfig: Configuration = {
  auth: {
    clientId: env.clientId,
    authority: env.authority,
    redirectUri: env.redirectUri,
    postLogoutRedirectUri: '/',
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage, // Better for SSO across tabs
  },
  system: {
    allowPlatformBroker: false, // Disable unless specifically needed
    loggerOptions: {
      logLevel: env.isDev ? LogLevel.Warning : LogLevel.Error,
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        if (containsPii || import.meta.env.VITE_APP_AUTH_LOGGING !== 'true') return;

        switch (level) {
          case LogLevel.Error:
            console.error('[MSAL]', message);
            break;
          case LogLevel.Warning:
            console.warn('[MSAL]', message);
            break;
          case LogLevel.Info:
            env.isDev && console.info('[MSAL]', message);
            break;
          case LogLevel.Verbose:
            env.isDev && console.debug('[MSAL]', message);
            break;
        }
      },
    },
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

export const msalScopes = {
  // Microsoft Graph API scopes (for user photo, profile, etc.)
  graph: ['User.Read'],
  // Combined scopes for login
  login: ['openid', 'profile', 'email', `api://${env.scopeId}/dbs.read`],
} as const;
